interface VerificationProgressProps {
  currentStep: number;
  totalSteps: number;
}

export const VerificationProgress = ({ currentStep, totalSteps }: VerificationProgressProps) => {
  const steps = ["Profile", "Documents", "Quiz"];

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        {steps.map((step, index) => (
          <div key={step} className="flex-1 text-center">
            <div className={`mx-auto w-8 h-8 rounded-full flex items-center justify-center mb-2 
              ${index + 1 <= currentStep ? 'bg-primary text-white' : 'bg-gray-200 text-gray-600'}`}
            >
              {index + 1}
            </div>
            <span className={`text-sm ${index + 1 <= currentStep ? 'text-primary' : 'text-gray-600'}`}>
              {step}
            </span>
          </div>
        ))}
      </div>
      <div className="relative">
        <div className="absolute top-0 h-1 bg-gray-200 w-full" />
        <div 
          className="absolute top-0 h-1 bg-primary transition-all duration-300" 
          style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }} 
        />
      </div>
    </div>
  );
};